import React, { useState } from 'react';
import _ from 'lodash';
import moment from 'moment';

import CellContent from './CellContent';
import { API_FLAG, DATE_TIME_FORMAT } from '../../../utilities/constants';
import { WorkHourModal } from '../../WorkHourModal';
import { Modal } from '../../Modal';
import { getErrorValidateWithId } from '../../../utilities/works';

const manHoursFormat = (manHours, stateHandlingFlag) => {
  if (stateHandlingFlag === API_FLAG.On) {
    return _.isNull(manHours) ? '0.0' : manHours;
  } else {
    // nullの場合は--に変換 nullだと何も表示できないのでクリックもできなくなる
    return _.isNull(manHours) ? '--' : manHours;
  }
};

/**
 * format time to HH:mm:ss
 * sample: 08:30 -> 08:30:00; 13:45:00 -> 13:45:00
 * @param time
 * @returns {string}
 */
const formatTimeSecond = time => {
  return moment(time, DATE_TIME_FORMAT.timeFormat).format(
    DATE_TIME_FORMAT.timeSecondFormat
  );
};

/**
 * format decimal number
 * sample: 1 -> 1.0; 3.25 -> 3.25; 4.5 -> 4.5
 * @param {number} number
 * @returns {string}
 */
export const formatDecimal = number => {
  return number.toLocaleString(undefined, { minimumFractionDigits: 1 });
};

const WorkDayWorkerTemplate = ({
  fieldInfo,
  isWorkSchedule,
  context,
  grid,
  handlePushParam,
  msgValidate,
  column,
  tabKeyStatus,
}) => {
  const [showModal, setShowModal] = useState(false);
  const {
    state_handling_flag,
    calcd_sum_schedule_man_hours,
    calcd_sum_man_hours,
    id,
    isAbortedOrApproved,
  } = context.item;

  const getError = () => {
    return getErrorValidateWithId(msgValidate, context.item, 'work_dayworkers');
  };

  const handleSetData = data => {
    _.each(data, (val, key) => {
      if (['work_early_times', 'work_over_times'].includes(key)) {
        _.forEach(val, time => {
          time.overtime_start = formatTimeSecond(time.overtime_start);
          time.earlytime_end = formatTimeSecond(time.earlytime_end);
        });
      }
      context.item[key] = val;
    });
    const sumDayWorker = _.sumBy(data.work_dayworkers, workDayWorker =>
      _.toNumber(workDayWorker.dayworker)
    );
    context.item.calcd_sum_man_hours = formatDecimal(sumDayWorker);
    const view = grid.collectionView;
    view.editItem(view.currentItem);
    view.currentItem['is_data_changed']['work_dayworkers'] = true;
    view.commitEdit();
    handlePushParam(context.item);
  };

  return (
    <CellContent
      isDataChanged={_.get(context, `item.is_data_changed.work_dayworkers`)}
      errorMsg={getError()}
      key={`${column}_${_.get(context, 'item.id')}`}
      errorTooltipId={`cell_${_.get(context, 'col.index')}_${_.get(
        context,
        'row.index'
      )}`}
    >
      <div className='btn-dialog-cell'>
        <span>
          {!isWorkSchedule && (
            <React.Fragment>
              <span>{calcd_sum_schedule_man_hours}</span> /{' '}
            </React.Fragment>
          )}
          {manHoursFormat(calcd_sum_man_hours, state_handling_flag)}
        </span>
        <button
          className={[
            isAbortedOrApproved ? 'btn-fixedsize--disabled' : '',
            'btn-fixedsize--sub btn-dialog',
          ].join(' ')}
          onClick={() => {
            !isAbortedOrApproved && setShowModal(true);
          }}
          tabIndex={tabKeyStatus}
        >
          人工を変更
        </button>
      </div>
      {showModal && (
        <Modal modalRoot='root' modalState={showModal}>
          <WorkHourModal
            onUpdate={handleSetData}
            onClose={() => setShowModal(false)}
            workId={id}
            workData={context.item}
            fieldInfo={fieldInfo}
            scheduleFlag={isWorkSchedule}
            isWorkBatchEdit={true}
          />
        </Modal>
      )}
    </CellContent>
  );
};

export default WorkDayWorkerTemplate;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/WorkDayWorkerTemplate.jsx